var selectCallback_cart = () => {};
var mf = "{{ shop.money_format }}";
selectCallback_cart = function(variant, selector) {
  var form = jQuery('#' + selector.domIdPrefix).closest('form');
  for (var i=0,length=1; i<length; i++) {
    var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
    if (radioButton.length) {
      radioButton.get(0).checked = true;
    }
  }
  if (variant) {
    form.find('.price').html(Shopify.formatMoney(variant.price, mf));
  }
  var cnt = 0;
  form.find('.swatch').each(function(im,v){
    if($(this).find('input[type="radio"]:checked').length == 0){
      form.find('.AddToCart_cart').addClass('disabled').attr('disabled', 'disabled');
      form.find('.AddToCart_cart').parent().addClass('disabled');
      if(form.hasClass('has_gft')){
        $(form).find('.AddToCart_cart').html('select an '+$(this).attr('data-opt_t'));
      }else{
        $(form).find('.AddToCart_cart').html('select a '+$(this).attr('data-opt_t'));
      }
      $('.size-select .only-left .sel_option').text('Size not selected');
      cnt++;
      return false;
    }
  });

  if(cnt > 0){

    return false;
  }
  if (variant) {
    if (variant && variant.available) {
      form.find('.AddToCart_cart').removeAttr('disabled').removeClass('disabled').html('add');
      form.find('.AddToCart_cart').parent().removeClass('disabled');
    } else {
      form.find('.AddToCart_cart').addClass('disabled').attr('disabled', 'disabled').html('sold Out');
      form.find('.AddToCart_cart').parent().addClass('disabled');
    }
    form.find('.price').html(Shopify.formatMoney(variant.price, mf));
  }else{
    var fo = selector.product.options[0];
    if(form.hasClass('has_gft')){
      $('.AddToCart_cart').addClass('disabled').attr('disabled', 'disabled').html('select an '+fo);
    }else{
      $('.AddToCart_cart').addClass('disabled').attr('disabled', 'disabled').html('select a '+fo);
    }
    $('.AddToCart_cart').parent().addClass('disabled');
  }
}
